var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"file-select"},[_c('div',{staticClass:"select-button"},[(_vm.value.length > 0)?_c('span',[_vm._v("Attachments: "+_vm._s(_vm.displayFiles))]):_c('span',[_vm._v("Add Attachments")])]),_vm._v(" "),_c('input',{attrs:{"type":"file","multiple":"true"},on:{"change":_vm.handleFileChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }